import React from "react";
import { Box } from "@mui/material";
import {
  MyTimesheetClientSettings,
  MyTimesheetCostSettings,
  MyTimesheetGeneralSettings,
  MyTimesheetProjectSettings,
} from "my-timesheet/components";
import { adminSettingsMenuDef } from "my-timesheet/configs/menu-defs";
import { OcPageSideMenu, OcPageTransition } from "oc/components";
import { useOcPageSideMenu } from "oc/hooks";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

export const MyTimesheetAdminSettingsPage = () => {
  const stateId = "mySheetSettingsPageMenuActiveItem";
  const { state: selectedItem } = useOcPageSideMenu({
    id: stateId,
    initialValue: adminSettingsMenuDef[0].id,
  });

  const isMobile = useOcIsMobile();
  return (
    <OcPageTransition>
      <Box>
        <Box
          id="my-hr-admin-settings-title"
          height="80px"
          style={{ backgroundColor: "#cc0033" }}
          display="flex"
          flexDirection="row"
          alignItems="center"
          paddingLeft="14px"
        >
          <Box style={{ color: "white", fontSize: "24px" }}>MyTimesheet</Box>
        </Box>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>
          <OcPageSideMenu stateId={stateId} menuDef={adminSettingsMenuDef} />
          <Box
            id="my-hr-admin-system-settings"
            flexGrow={1}
            padding={isMobile ? "16px 0px" : "16px"}
          >
            {selectedItem === "mySheetGeneralSettings" && (
              <MyTimesheetGeneralSettings isMobile={isMobile} />
            )}
            {selectedItem === "mySheetProjectSettings" && (
              <MyTimesheetProjectSettings isMobile={isMobile} />
            )}
            {selectedItem === "mySheetClientSettings" && (
              <MyTimesheetClientSettings isMobile={isMobile} />
            )}
            {selectedItem === "mySheetCostSettings" && (
              <MyTimesheetCostSettings isMobile={isMobile} />
            )}
          </Box>
        </Box>
      </Box>
    </OcPageTransition>
  );
};

export default MyTimesheetAdminSettingsPage;
